module.exports = __webpack_public_path__ + "img/wb_logo_ebn-w.bda9ed67.svg";